import { AbstractControl, ValidationErrors } from '@angular/forms';
import { InvoiceableWorkOrderItem } from '../../domains/models/invoiceable-work-order-item';
import { totalNormalizedPrice } from '../pipes/total-normalized-price.pipe';
import { totalDeductions } from '../pipes/total-price.pipe';

/**
 * The part of a line's deductions smaller than one unit comes off this invoice in money, so the units invoiced on
 * the line must be worth at least that much, or the line would invoice a negative amount. Only possible on lines
 * invoiced in fractions (hours, 0.25 steps); a whole unit always covers it.
 */
export const amountCoversDeductionRemainder =
  (item?: InvoiceableWorkOrderItem) =>
  (target: AbstractControl): ValidationErrors | null => {
    if (!target.value || !item?.applicableChangeOrders?.length) {
      return null;
    }
    const remainder = +(
      totalDeductions(item.applicableChangeOrders) - totalNormalizedPrice(item.applicableChangeOrders, item.pricePerUnit)
    ).toFixed(2);
    return +(target.value * (item.pricePerUnit ?? 0)).toFixed(2) >= remainder ? null : { minAmount: true };
  };
